export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 SIMILAR SYMPTOMS. TOO MANY POSSIBLE CAUSES.',
    body: 'Yellow leaves? Brown edges? Interveinal chlorosis? Stunted growth? Without organized visual comparisons, distinguishing nutritional disorders can become a frustrating process of comparing scattered information.',
  },
  {
    title: "⚠️ YOU RECOGNIZE THE SYMPTOM—BUT WHAT'S CAUSING IT?",
    body: "Yellowing doesn't automatically mean nitrogen deficiency. Leaf necrosis doesn't always indicate potassium deficiency. Without proper symptom comparison and supporting evidence, nutritional problems can easily be misinterpreted.",
  },
  {
    title: '📚 YOUR AGRONOMIC REFERENCES ARE EVERYWHERE',
    body: "Crop nutrition charts, soil reports, tissue analysis results, deficiency photographs, fertilizer records, and technical manuals. The information exists—but it's scattered when you need to evaluate a crop problem.",
  },
  {
    title: '😩 STOP INVESTIGATING EVERY NUTRITIONAL PROBLEM FROM SCRATCH',
    body: 'Comparing possible deficiencies without a clear assessment process wastes valuable time. Approach each crop nutrition concern with organized visual references, laboratory interpretation, and structured evaluation tools.',
  },
]
